import * as React from 'react';
import { ArticleHeading2, Image } from '@cian/ui-kit';

import * as styles from './PromoDescription.css';
import { IPromoProp } from '../../../../types/promosPage';
import { PromoFeatures } from '../../../PromoFeatures';

interface IPromoDescriptionProps {
  description?: string | null;
  features: IPromoProp[];
  logo: string;
  name: string;
}

export const PromoDescription: React.FC<IPromoDescriptionProps> = ({ description, features, logo, name }) => {
  return (
    <>
      <div className={styles['header']}>
        <div className={styles['title']}>
          <ArticleHeading2 as="h2">{name}</ArticleHeading2>
        </div>
        <div className={styles['logo']}>
          <Image src={logo} borderRadius="0" />
        </div>
      </div>
      {features.length > 0 && (
        <div className={styles['features-list']}>
          <PromoFeatures features={features} />
        </div>
      )}
      {description && <p className={styles['description']}>{description}</p>}
    </>
  );
};
